var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs3":""}},[_vm._v(_vm._s(_vm.label)+":")]),_c('v-flex',[_vm._v(_vm._s(_vm.value ? _vm.value : '-'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }